import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'

/**
 * Component that forces the link to return to the top of the page.
 * @return {JSX.Element}
 */
export const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [pathname]);

    return null;
};